module.exports = {"id":"203801","name":"Francisco Silva","rating":"73","photo":"./data/images/photos/4/203801.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FranciscoSilva0.json
// module id = 1474
// module chunks = 0